/* eslint-disable */
const globalMixin = {
    data() {
        return {
        }
    },
    methods: {
        openLoading(title) {
            Swal.fire({
                title,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            })
        },
        isTokenExpired() {
            const expiry = (JSON.parse(Buffer.from(localStorage.userToken.split('.')[1], 'base64'))).exp;
            console.log(expiry)
            console.log('date: ' + (Math.floor((new Date).getTime() / 1000)))

            if ((Math.floor((new Date).getTime() / 1000)) >= expiry) {
                window.localStorage.clear()
                router.push('/')
            }

        },
        formatDate(value) {
            const date = new Date(value.toString());
            return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
        },
        formatDateTime(value) {
            const date = new Date(value.toString());
            return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear() + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0')
        },
        formatTime(value) {
            const date = new Date(value.toString());
            return date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0')
        },        
        formatCurrency(value) {
            if (value == null)
                return ''
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        sumOfArrayWithParameter(array, parameter) {
            if (array.length == 0)
                return 0;

            let sum = null;
            if (array && array.length > 0 && typeof parameter === 'string') {
                sum = 0;
                for (let e of array) if (e && e.hasOwnProperty(parameter)) sum += e[parameter];
            }
            return sum;
        },

        //formatDate(value) {
        //    return value.toLocaleDateString('en-US', {
        //        day: '2-digit',
        //        month: '2-digit',
        //        year: 'numeric',
        //    });
        //},
        logout() {
            window.localStorage.clear()
            router.push('/')
        },
        showSuccess(sInfoMessage, sMessage) {
            this.$toast.add({ severity: 'success', summary: sInfoMessage, detail: sMessage, life: 3000 });
        },
        showInfo(sInfoMessage, sMessage) {
            this.$toast.add({ severity: 'info', summary: sInfoMessage, detail: sMessage, life: 3000 });
        },
        showWarn(sInfoMessage, sMessage) {
            this.$toast.add({ severity: 'warn', summary: sInfoMessage, detail: sMessage, life: 3000 });
        },
        showError(sInfoMessage, sMessage) {
            this.$toast.add({ severity: 'error', summary: sInfoMessage, detail: sMessage, life: 3000 });
        },

        getTickePrinterName()
        {
            const encrypted = localStorage.getItem(STORAGE_KEY_TICKET_PRINTER);
            
            if (encrypted) {
                try {
                    const bytes = cryptoJs.AES.decrypt(encrypted, SECRET_KEY);
                    const decrypted = bytes.toString(cryptoJs.enc.Utf8);
                    return decrypted;
                } catch (e) {
                    console.warn('No se pudo obtener la impresora guardada' + e);
                }
            }            
        },

 
        
        async printTicket(idSale) {
            let ticketCode = '';
            let printerName = '';

            try {
                // Paso 1: Obtener el código del ticket desde la API en la nube
                const response = await axios.get(apiURL + 'Sales/printSaleTicket?idSale=' + idSale, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.userToken
                    }
                });

                const result = response.data;

                if (Array.isArray(result.sErrors) && result.sErrors.length > 0) {
                    const errorMsg = result.sErrors.join(', ');
                    throw new Error(`Error al obtener los datos del ticket: ${errorMsg}`);
                }                

                ticketCode = this.base64ToEscPosString(response.data.sValue);
                if (!ticketCode) {
                    throw new Error('La API devolvió un código de ticket vacío.');
                }

            } catch (error) {
                this.showError("Error", 'Ocurrio un error al obtener los datos para imprimir el ticket: ' + error)
                return;
            }

            try {
                // Paso 2: Obtener el nombre de la impresora seleccionada localmente
                printerName = this.getTickePrinterName(); // asegúrate de que esta función devuelve un string
                console.log(printerName);
                if (!printerName || typeof printerName !== 'string') {
                    throw new Error('No se encontró una impresora configurada.');
                }

            } catch (error) {
                this.showError("Error", 'Error:' + error)
                return;
            }

            try {
                // Paso 3: Enviar el ticket al servicio local de impresión
                const printModel = {
                printerName: printerName,
                escPosData: ticketCode
                };

                await axios.post(apiPrinter, printModel, {
                headers: {
                    'Content-Type': 'application/json'
                }
                });

            } catch (error) {
                this.showError("Error", 'Error al imprimir el ticket: ' + error)
                return;
            }
        },

        base64ToEscPosString(base64) {
            const binaryString = atob(base64); // decodifica Base64 a cadena binaria
            // Convierte cada carácter a código de byte y genera string ISO-8859-1 compatible
            let escPosString = '';
            for (let i = 0; i < binaryString.length; i++) {
                escPosString += String.fromCharCode(binaryString.charCodeAt(i));
            }
            return escPosString;
        }
                
    }
}

export default globalMixin